












import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class TableAlert extends Vue {
  @Prop(Number) readonly selectNum!: number;
  @Prop(Function) readonly clearSelection!: () => void;
}
